import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAttributes from '../lockupAttributes'
import LockupFilesIncluded from '../lockupFilesIncluded'
import LockupTagsOnMobile from '../lockupTagsOnMobile'

import FeatureContainer from '../../../containers/feature'
import CommonItemCardLayout from '../commonItemCardLayout'

const CodeCanyonItemCard = (props: IItemCard) => {
  const { tags = '', term = '' } = props.locationParams
  return (
    <CommonItemCardLayout {...props}>
      <LockupAttributes {...props} />
      <LockupFilesIncluded {...props} />
      <FeatureContainer name="!shouldRemoveTags">
        <LockupTagsOnMobile {...props} tags={tags} term={term} />
      </FeatureContainer>
    </CommonItemCardLayout>
  )
}

export default CodeCanyonItemCard
